import { graphql } from "gatsby";
import React, { FC, useCallback } from "react";

import { useDataLayer } from "../../hooks/use-data-layer";
import { GoogleAnalyticsEvent } from "../../utils/analytics";
import { FooterBottom } from "./footer-bottom";
import { FooterInnerCard } from "./footer-inner-card";
import { FooterTop } from "./footer-top";

export interface FooterProps extends Queries.FooterDataFragment {
  subscriptionAction?: () => void;
  assistanceAction?: () => void;
}

export const Footer: FC<FooterProps> = ({
  subscriptionTitle,
  subscriptionAbstract,
  subscriptionCta,
  assistanceTitle,
  assistanceAbstract,
  assistanceCta,
  facebookUrl,
  youtubeUrl,
  linkedinUrl,
  instagramUrl,
  companyInfo,
  bottomLinks,
}) => {
  const { pushEvent } = useDataLayer();
  const onPushEvent = useCallback(
    (type: string) => {
      pushEvent({
        event: GoogleAnalyticsEvent.ClickFooter,
        footer_action: type,
      });
    },
    [pushEvent]
  );
  return (
    <div className="flex flex-col bg-dark w-full px-8 lg:px-20 pt-12 lg:pt-16 pb-24 lg:pb-10 gap-12 lg:gap-0">
      <FooterTop {...{ facebookUrl, youtubeUrl, linkedinUrl, instagramUrl }} />
      <div className="flex flex-col lg:flex-row gap-12 lg:gap-14 mb-5 lg:mb-24">
        <FooterInnerCard
          title={subscriptionTitle}
          abstract={subscriptionAbstract}
          cta={subscriptionCta}
          onClickCta={() => {
            onPushEvent(GoogleAnalyticsEvent.Newsletter);
          }}
        />
        <FooterInnerCard
          variant="primary"
          title={assistanceTitle}
          abstract={assistanceAbstract}
          cta={assistanceCta}
          onClickCta={() => {
            onPushEvent(GoogleAnalyticsEvent.Request);
          }}
        />
      </div>
      <FooterBottom {...{ companyInfo, bottomLinks }} />
    </div>
  );
};

export const query = graphql`
  fragment FooterData on ContentfulFooter {
    __typename

    subscriptionTitle
    subscriptionAbstract
    subscriptionCta {
      ...CtaData
    }

    assistanceTitle
    assistanceAbstract
    assistanceCta {
      ...CtaData
    }

    companyInfo
    bottomLinks {
      ...CtaData
    }

    facebookUrl
    instagramUrl
    linkedinUrl
    youtubeUrl
  }
`;
